import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useTenantBrand } from "@/context/TenantBrandContext";

export default function TenantEntry() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { setBrand } = useTenantBrand();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/public/tenant-by-slug/${encodeURIComponent(slug)}`)
      .then((r) => {
        setBrand(r.data.tenant);
        navigate("/login", { replace: true });
      })
      .catch(() => setNotFound(true));
  }, [slug, setBrand, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#040D1D] text-white" data-testid="tenant-entry">
      {notFound ? (
        <>
          <p className="text-lg font-semibold" data-testid="tenant-entry-notfound">Sekolah tidak ditemukan</p>
          <Link to="/login" className="mt-3 text-sm text-[#00D1A8] hover:underline">Ke halaman masuk umum</Link>
        </>
      ) : (
        <Loader2 className="h-8 w-8 animate-spin text-[#00D1A8]" />
      )}
    </div>
  );
}
